module.exports = __webpack_public_path__ + "img/P1070847.f6ae966f.jpg";